// src/redux/reducers/projetReducer.js
import {
    FETCH_MY_PROJETS_REQUEST,
    FETCH_MY_PROJETS_SUCCESS,
    FETCH_MY_PROJETS_FAIL,
    FETCH_ALL_PROJETS_REQUEST,
    FETCH_ALL_PROJETS_SUCCESS,
    FETCH_ALL_PROJETS_FAIL,
    CREATE_PROJET_SUCCESS,
    UPDATE_PROJET_SUCCESS,
    DELETE_PROJET_SUCCESS,
} from "../actions/projetActions";

const initialState = {
    myProjets: [],
    allProjets: [],
    loading: false,
    error: null
};

export default function projetReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_MY_PROJETS_REQUEST:
        case FETCH_ALL_PROJETS_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_MY_PROJETS_SUCCESS:
            return { ...state, loading: false, myProjets: action.payload || [], error: null };

        case FETCH_ALL_PROJETS_SUCCESS:
            return { ...state, loading: false, allProjets: action.payload || [], error: null };

        case FETCH_MY_PROJETS_FAIL:
        case FETCH_ALL_PROJETS_FAIL:
            return { ...state, loading: false, error: action.payload };

        case CREATE_PROJET_SUCCESS:
            return { ...state, allProjets: [...state.allProjets, action.payload] };

        case UPDATE_PROJET_SUCCESS:
            return {
                ...state,
                allProjets: state.allProjets.map(p =>
                    p.id === action.payload.id ? action.payload : p
                ),
            };

        case DELETE_PROJET_SUCCESS:
            return {
                ...state,
                allProjets: state.allProjets.filter(p => p.id !== action.payload),
            };

        default:
            return state;
    }
}
